import { Card, CardContent, CardHeader, CircularProgress, Container, Divider, Grid, Paper, Snackbar, Backdrop, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser, CreateWareHouseAddress } from 'src/utils/Common';
import LeftPane from './LeftPane';
import RightPane from './RightPane';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const defaultUyari = { open: false, aciklama: '', tip: 'success' };

function Purchase() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [rowIndex, setRowIndex] = useState(0);
  const [data, setData] = useState([]);
  const [uyari, setUyari] = useState(defaultUyari);
  const [company, setCompany] = useState('');
  const [description, setDescription] = useState('');
  const [openDialog, setOpenDialog] = useState(false); // Dialog visibility state
  const user1 = getUser();

  useEffect(() => {
    CreateWareHouseAddress(user1.ServiceShopId);
  }, []);

  const addMaterial = (materialId, materialCode, materialDesc) => {
    axios.get(`GetDepoAdetFiyat/${materialCode}/${user1.ServiceShopId}/${user1.TechnicianId}`)
      .then(response => {
        var DepoAdet = response.data.split('|')[0];
        var KdvliFiyat = response.data.split('|')[1];
        var ADRES_ADET = response.data.split('|')[2];
        var WarehouseAddressText = response.data.split('|')[3];
        var WarehouseAddress = response.data.split('|')[4];

        var varMi = data.filter(d => d.materialCode.replace(/^0+/, '') === materialCode);
        if (varMi.length > 0) {
          var filteredRowIndex = data.findIndex(d => d.materialCode.replace(/^0+/, '') === materialCode);
          data.splice(filteredRowIndex, 1);
          varMi[0].Count = parseInt(varMi[0].Count) + 1;
          varMi[0].DEPO_ADET = DepoAdet;
          varMi[0].KDVLIFIYAT = KdvliFiyat;
          varMi[0].ADRES_ADET = ADRES_ADET;
          varMi[0].WarehouseAddressText = WarehouseAddressText;
          varMi[0].WarehouseAddress = WarehouseAddress;
          let DegerOld = [...data, varMi[0]];
          setData(DegerOld);
        } else {
          setRowIndex(rowIndex + 1);
          let datas = {
            index: rowIndex,
            materialId: materialId,
            materialCode: materialCode,
            materialDesc: materialDesc,
            Count: 1,
            DEPO_ADET: DepoAdet,
            ADRES_ADET: ADRES_ADET,
            WarehouseAddressText: WarehouseAddressText,
            KDVLIFIYAT: KdvliFiyat,
            WarehouseAddress: WarehouseAddress,
          };
          setData([...data, datas]);
        }
      }).catch(error => {
        console.log(error);
      })
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  const handleConfirmContinue = () => {
    setOpenDialog(false);
    saveMaterials(true);
  };


  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const saveMaterials = (isConfirmed = false) => {
  if (company.length === 0) {
    setUyari({ open: true, aciklama: 'Firma belirtiniz!..', tip: 'error' });
    return;
  }
  if (description.length === 0) {
    setUyari({ open: true, aciklama: 'Açıklama yazınız!..', tip: 'error' });
    return;
  }
  if (data.length === 0) {
    setUyari({ open: true, aciklama: 'Malzeme girişi yapınız!..', tip: 'error' });
    return;
  }

  let warehouse = data.filter(d => parseInt(d.WarehouseAddress) === 0);
  if (warehouse.length > 0) {
      setUyari({ open: true, aciklama: warehouse[0].materialCode + ' kodlu malzemeniz için depo adres bilgisi giriniz!..', tip: 'error' });
      return;
    }
  const user = getUser();
  if (!isConfirmed) {
    setOpenDialog(true);
    return;
  }

  setLoading(true);
  const postData = {
    ServiceShopId: user.ServiceShopId,
    UserId: user.OrganizationUserId,
    Company: company,
    Description: description,
    Materials: data.map(d => ({
      MaterialId: d.materialId,
      Count: d.Count,
      WarehouseAddress: d.WarehouseAddress,
    }))
  };

  axios.post('/SetMaterialLoginPurchase', postData, {
    headers: { 'Content-Type': 'application/json' }
  }).then(response => {
    if (response.data.ErrorCode === "0") {
      setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
      setData([]);
      setCompany('');
      setDescription('');
    } else {
      setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
      setData([]);
      setCompany('');
      setDescription('');
    }
  }).catch(error => {
    setUyari({ open: true, aciklama: 'Bir hata oluştu!.. ' + error.message, tip: 'error' });
  }).finally(() => {
    setLoading(false);
  });
};


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Stok Girişi - Satın Alma" />
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000} anchorOrigin={{ vertical: "top", horizontal: "center" }} onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>{uyari.aciklama || ''}</Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Paper>
                  <LeftPane setLoading={setLoading} company={company} setCompany={setCompany} description={description} setDescription={setDescription} />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={9}>
                <RightPane setLoading={setLoading} data={data} setData={setData} addMaterial={addMaterial} saveMaterials={saveMaterials} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Onay</DialogTitle>
        <DialogContent>
          Satınalma girişiniz mühendisinize onaya gönderilecektir. Onaylıyor musunuz?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Hayır
          </Button>
          <Button onClick={handleConfirmContinue} color="primary">
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Purchase;
